import type { FaireProductEntity } from "../../entity_types/product";

export const p_dd1ax8b7xy: FaireProductEntity = {
  token: "p_dd1ax8b7xy",
  type: "product",
  name: "CLEARANCE Mini Travel Bath Salts \u2013 Strawberry & Raspberry ",
  brandName: "Bella & Bear",
  imageUrl:
    "https://cdn.faire.com/fastly/8e796eab07f37cbba30ddadea2750cff56b1c050d20a4f41a9c05f58be58afd2.jpeg",
  priceDollars: 1,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/1c5e910ec6dfcc81389b94f56f8fd01536a7d8dd14ba74d1c6280b9224c093d7.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
